export default __webpack_public_path__ + "static/media/Snare1.67b24b6c.mp3";